"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentGateway = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
//@ts-ignore                
let rwsTemplate = T.html `${(0, fast_element_1.when)(x => !x.hideGatewayElements, (0, fast_element_1.html) `<div class="payment-gateway">
    <div class="payment-header">
        <h3>${x => 'payment.gateway'.t()}</h3>
    </div>

    <div class="provider-selection">
        <h4>${'payment.selectProvider'.t()}</h4>
        <div class="provider-options">
            <label class="provider-option">
                <input 
                    type="radio" 
                    name="paymentProvider" 
                    value="stripe" 
                    :checked="${x => x.provider === 'stripe'}"
                    @change="${(x, c) => x.handleProviderChange(c.event)}" />
                <span class="provider-label">
                    <span class="provider-name">Stripe</span>
                    <span class="provider-description">${'payment.provider.stripe.description'.t()}</span>
                </span>
            </label>
            
            <label class="provider-option">
                <input 
                    type="radio" 
                    name="paymentProvider" 
                    value="przelewy24" 
                    :checked="${x => x.provider === 'przelewy24'}"
                    @change="${(x, c) => x.handleProviderChange(c.event)}" />
                <span class="provider-label">
                    <span class="provider-name">Przelewy24</span>
                    <span class="provider-description">${'payment.provider.przelewy24.description'.t()}</span>
                </span>
            </label>
        </div>
    </div>

    <div class="payment-form" ?hidden="${x => x.paymentId && x.paymentStatus === backendImport_1.PaymentStatus.SUCCESS}">
        <div class="payment-details">
            <div class="form-group">
                <label>${'payment.amount'.t()}</label>
                <div class="amount-display">${x => x.formattedAmount}</div>
            </div>

            <div class="form-group" ?hidden="${x => !x.description}">
                <label>${'payment.description'.t()}</label>
                <div class="description-display">${x => x.description}</div>
            </div>           
        </div>

        <div class="payment-actions">
            <button 
                class="btn btn-primary payment-btn"
                @click="${x => x.initializePayment()}"                
                ?hidden="${x => x.paymentId && x.clientSecret && x.provider === backendImport_1.PaymentProvider.STRIPE}">
                <span ?hidden="${x => x.loading}">${'payment.initiate'.t()}</span>
                <span ?hidden="${x => !x.loading}" class="loading-spinner">${'common.loading'.t()}...</span>
            </button>            
        </div>
    </div>    

    
    <div class="p24-payment-section" ?hidden="${x => x.provider !== backendImport_1.PaymentProvider.PRZELEWY24 || !x.paymentUrl}">
        <div class="p24-info">
            <p>${'payment.p24.redirectInfo'.t()}</p>
            <a href="${x => x.paymentUrl}" class="btn btn-primary payment-link" target="_blank">
                ${'payment.p24.goToPayment'.t()}
            </a>
        </div>
    </div>

    
    <div class="payment-status" ?hidden="${x => !x.paymentId}">
        <h4>${'payment.status'.t()}</h4>
        
        <div class="status-info">
            <div class="payment-id">
                <strong>${'payment.id'.t()}:</strong> ${x => x.paymentId}
            </div>
            
            <div class="status-display">
                <strong>${'payment.currentStatus'.t()}:</strong>
                <span class="status-badge status-${x => x.paymentStatus}">
                    ${x => x.getStatusText()}
                </span>
            </div>
        </div>        

        <button 
            class="btn btn-outline refresh-status-btn"
            @click="${x => x.checkPaymentStatus()}"
            ?disabled="${x => x.loading}">
            <span ?hidden="${x => x.loading}">${'payment.refreshStatus'.t()}</span>
            <span ?hidden="${x => !x.loading}" class="loading-spinner">${'common.loading'.t()}...</span>
        </button>
    </div>

    
    <div class="payment-messages">
        <div class="success-message" ?hidden="${x => !x.successMessage}">
            <div class="alert alert-success">
                ${x => x.successMessage}
            </div>
        </div>

        <div class="error-message" ?hidden="${x => !x.errorMessage}">
            <div class="alert alert-error">
                ${x => x.errorMessage}
            </div>
        </div>
    </div>

    
    <div class="payment-reset" ?hidden="${x => !x.paymentId}">
        <button 
            class="btn btn-outline reset-btn"
            @click="${x => x.reset()}">
            ${'payment.reset'.t()}
        </button>
    </div>
</div>`)}`;
require("./styles/layout.scss");
const styles = T.css `.payment-gateway {
  max-width: 600px;
  margin: 0 auto;
  padding: 24px;
  background: var(--color-neutral-layer-1, #ffffff);
  border: 1px solid var(--color-neutral-stroke-rest, #e0e0e0);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.payment-gateway .payment-header {
  margin-bottom: 24px;
  text-align: center;
}
.payment-gateway .payment-header h3 {
  margin: 0;
  color: var(--color-neutral-foreground-rest, #323130);
  font-size: 1.5rem;
  font-weight: 600;
}
.payment-gateway .payment-info {
  margin-bottom: 24px;
  padding: 16px;
  background: var(--color-neutral-layer-2, #faf9f8);
  border-radius: 6px;
  border-left: 4px solid var(--color-brand-background-1, #0078d4);
}
.payment-gateway .payment-info .payment-name h4 {
  margin: 0 0 8px 0;
  color: var(--color-neutral-foreground-rest, #323130);
  font-size: 1rem;
  font-weight: 600;
}
.payment-gateway .payment-info .payment-name p {
  margin: 0;
  color: var(--color-neutral-foreground-2, #605e5c);
  font-size: 0.95rem;
  line-height: 1.4;
}
.payment-gateway .provider-selection {
  margin-bottom: 24px;
  padding: 20px;
  background: var(--color-neutral-layer-2, #faf9f8);
  border-radius: 8px;
  border: 1px solid var(--color-neutral-stroke-rest, #e0e0e0);
}
.payment-gateway .provider-selection h4 {
  margin: 0 0 16px 0;
  color: var(--color-neutral-foreground-rest, #323130);
  font-size: 1.1rem;
  font-weight: 600;
}
.payment-gateway .provider-selection .provider-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.payment-gateway .provider-selection .provider-option {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: var(--color-neutral-layer-1, #ffffff);
  border: 2px solid var(--color-neutral-stroke-rest, #e0e0e0);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.payment-gateway .provider-selection .provider-option:hover {
  border-color: var(--color-brand-stroke-1, #0078d4);
  background: var(--color-neutral-background-hover, #f3f2f1);
}
.payment-gateway .provider-selection .provider-option input[type=radio] {
  margin: 4px 12px 0 0;
  accent-color: var(--color-brand-background-1, #0078d4);
  transform: scale(1.2);
}
.payment-gateway .provider-selection .provider-option:has(input:checked) {
  border-color: var(--color-brand-background-1, #0078d4);
  background: var(--color-brand-background-tint, #deecf9);
}
.payment-gateway .provider-selection .provider-option .provider-label {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.payment-gateway .provider-selection .provider-option .provider-label .provider-name {
  font-weight: 600;
  color: var(--color-neutral-foreground-rest, #323130);
  margin-bottom: 4px;
}
.payment-gateway .provider-selection .provider-option .provider-label .provider-description {
  font-size: 0.9rem;
  color: var(--color-neutral-foreground-2, #605e5c);
  line-height: 1.4;
}
.payment-gateway .payment-form {
  margin-bottom: 24px;
}
.payment-gateway .payment-form .payment-details {
  margin-bottom: 20px;
}
.payment-gateway .payment-form .payment-details .form-group {
  margin-bottom: 16px;
}
.payment-gateway .payment-form .payment-details .form-group label {
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
  color: var(--color-neutral-foreground-rest, #323130);
}
.payment-gateway .payment-form .payment-details .form-group .amount-display {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--color-brand-foreground-1, #0078d4);
}
.payment-gateway .payment-form .payment-details .form-group .description-display,
.payment-gateway .payment-form .payment-details .form-group .session-id {
  padding: 8px 12px;
  background: var(--color-neutral-layer-2, #faf9f8);
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9rem;
  word-break: break-all;
}
.payment-gateway .payment-form .payment-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.payment-gateway .stripe-payment-section,
.payment-gateway .p24-payment-section {
  margin-bottom: 24px;
  padding: 16px;
  background: var(--color-neutral-layer-2, #faf9f8);
  border-radius: 6px;
  border-left: 4px solid var(--color-brand-background-1, #0078d4);
}
.payment-gateway .stripe-payment-section .stripe-info p,
.payment-gateway .stripe-payment-section .p24-info p,
.payment-gateway .p24-payment-section .stripe-info p,
.payment-gateway .p24-payment-section .p24-info p {
  margin: 0 0 12px 0;
  color: var(--color-neutral-foreground-2, #605e5c);
}
.payment-gateway .stripe-payment-section .stripe-info .client-secret-display,
.payment-gateway .stripe-payment-section .p24-info .client-secret-display,
.payment-gateway .p24-payment-section .stripe-info .client-secret-display,
.payment-gateway .p24-payment-section .p24-info .client-secret-display {
  margin-top: 12px;
}
.payment-gateway .stripe-payment-section .stripe-info .client-secret-display .client-secret,
.payment-gateway .stripe-payment-section .p24-info .client-secret-display .client-secret,
.payment-gateway .p24-payment-section .stripe-info .client-secret-display .client-secret,
.payment-gateway .p24-payment-section .p24-info .client-secret-display .client-secret {
  display: block;
  margin-top: 4px;
  padding: 8px;
  background: var(--color-neutral-layer-1, #ffffff);
  border: 1px solid var(--color-neutral-stroke-rest, #e0e0e0);
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8rem;
  word-break: break-all;
}
.payment-gateway .stripe-payment-section .payment-link,
.payment-gateway .p24-payment-section .payment-link {
  display: inline-block;
  margin-top: 8px;
}
.payment-gateway .payment-status {
  margin-bottom: 24px;
  padding: 16px;
  background: var(--color-neutral-layer-2, #faf9f8);
  border-radius: 6px;
}
.payment-gateway .payment-status h4 {
  margin: 0 0 16px 0;
  color: var(--color-neutral-foreground-rest, #323130);
  font-size: 1.1rem;
}
.payment-gateway .payment-status .status-info {
  margin-bottom: 16px;
}
.payment-gateway .payment-status .status-info .payment-id,
.payment-gateway .payment-status .status-info .status-display {
  margin-bottom: 8px;
}
.payment-gateway .payment-status .status-info .payment-id strong,
.payment-gateway .payment-status .status-info .status-display strong {
  color: var(--color-neutral-foreground-rest, #323130);
}
.payment-gateway .payment-status .status-info .status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}
.payment-gateway .payment-status .status-info .status-badge.status-1 {
  background: var(--color-warning-background, #fff4ce);
  color: var(--color-warning-foreground, #8a6914);
}
.payment-gateway .payment-status .status-info .status-badge.status-2 {
  background: var(--color-success-background, #dff6dd);
  color: var(--color-success-foreground, #107c10);
}
.payment-gateway .payment-status .status-info .status-badge.status-3 {
  background: var(--color-danger-background, #fde7e9);
  color: var(--color-danger-foreground, #d13438);
}
.payment-gateway .payment-status .status-info .status-badge.status-99 {
  background: var(--color-danger-background, #fde7e9);
  color: var(--color-danger-foreground, #d13438);
}
.payment-gateway .payment-messages {
  margin-bottom: 24px;
}
.payment-gateway .payment-messages .alert {
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 12px;
}
.payment-gateway .payment-messages .alert.alert-success {
  background: var(--color-success-background, #dff6dd);
  color: var(--color-success-foreground, #107c10);
  border: 1px solid var(--color-success-border, #107c10);
}
.payment-gateway .payment-messages .alert.alert-error {
  background: var(--color-danger-background, #fde7e9);
  color: var(--color-danger-foreground, #d13438);
  border: 1px solid var(--color-danger-border, #d13438);
}
.payment-gateway .payment-reset {
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid var(--color-neutral-stroke-rest, #e0e0e0);
}
.payment-gateway .payment-reset .reset-btn {
  font-size: 0.85rem;
  padding: 8px 16px;
}
@media (max-width: 768px) {
  .payment-gateway {
    padding: 16px;
  }
  .payment-gateway .payment-info {
    padding: 12px;
  }
  .payment-gateway .provider-selection {
    padding: 16px;
  }
  .payment-gateway .provider-selection .provider-options {
    gap: 8px;
  }
  .payment-gateway .provider-selection .provider-option {
    padding: 12px;
  }
  .payment-gateway .payment-actions {
    flex-direction: column;
  }
  .payment-gateway .payment-actions .btn {
    width: 100%;
    text-align: center;
  }
  .payment-gateway .stripe-payment-section,
  .payment-gateway .p24-payment-section {
    padding: 12px;
  }
  .payment-gateway .payment-status {
    padding: 12px;
  }
}

[hidden] {
  display: none !important;
}`;
const shadowOptions = { "mode": "open" };
let PaymentGateway = class PaymentGateway extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.paymentName = ''; // Description of what operation is being paid for
        this.provider = backendImport_1.PaymentProvider.STRIPE; // Selected payment provider
        this.description = '';
        this.sessionId = '';
        this.billingPeriod = 'monthly';
        this.currency = 'USD';
        this.loading = false;
        this.hideGatewayElements = false;
        this.paymentStatus = backendImport_1.PaymentStatus.PENDING;
        this.paymentUrl = '';
        this.paymentId = '';
        this.errorMessage = '';
        this.successMessage = '';
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.sessionId) {
            this.sessionId = this.generateSessionId();
        }
        console.log(this.accountGrade);
        if (this.accountGrade && this.accountGrade.price) {
            if (this.billingPeriod === 'yearly') {
                this.amount = this.accountGrade.yearlyPrice || (this.accountGrade.price * 12);
            }
            else {
                this.amount = this.accountGrade.price;
            }
        }
    }
    /**
     * Generate a unique session ID for the payment
     */
    generateSessionId() {
        return 'pay_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }
    /**
     * Initialize payment process
     */
    async initializePayment() {
        var _a;
        if (!this.validatePaymentData()) {
            return;
        }
        this.loading = true;
        this.errorMessage = '';
        this.successMessage = '';
        try {
            const response = await this.apiService.back.post('payment.create', {
                provider: this.provider,
                amount: this.amount, // Frontend amount (can be any currency for display)
                currency: this.currency.toLowerCase(),
                description: this.description || this.paymentName || 'payment.defaultDescription'.t(),
                sessionId: this.sessionId,
                email: this.getCurrentUserEmail(),
                urlReturn: `${window.location.origin}/payment/success`,
                country: 'PL',
                language: 'pl',
                accountGradeId: Number((_a = this.accountGrade) === null || _a === void 0 ? void 0 : _a.id), // Backend will use AccountGrade.price (USD)
                paymentName: this.paymentName,
                billingPeriod: this.billingPeriod
            });
            if (response && response.success) {
                this.paymentId = response.data.paymentId;
                if (this.provider === backendImport_1.PaymentProvider.STRIPE) {
                    this.handleStripePayment(response.data.clientSecret);
                }
                else {
                    this.errorMessage = 'payment.unsupportedProvider'.t();
                    return;
                }
                this.successMessage = 'payment.initialized'.t();
                this.$emit('payment-initialized', {
                    paymentId: this.paymentId,
                    provider: this.provider
                });
            }
            else {
                this.errorMessage = (response && response.error) || 'payment.initializationFailed'.t();
            }
        }
        catch (error) {
            console.error('Payment initialization error:', error);
            this.errorMessage = 'payment.initializationFailed'.t();
            this.notifyService.notify(this.errorMessage, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Handle Stripe payment flow
     */
    async handleStripePayment(clientSecret) {
        if (!clientSecret) {
            this.errorMessage = 'payment.stripe.noClientSecret'.t();
            return;
        }
        // Emit event for parent component to handle Stripe Elements
        this.$emit('stripe-payment-ready', {
            clientSecret: clientSecret,
            paymentId: this.paymentId
        });
        const scriptElement = document.createElement('script');
        scriptElement.src = 'https://js.stripe.com/v3/';
        scriptElement.async = true;
        const stripePaymentElement = document.createElement('div');
        stripePaymentElement.id = 'stripe-payment-element';
        const stripeForm = document.createElement('form');
        stripeForm.id = 'stripe-form';
        stripeForm.classList.add('utility-modal');
        const submitButton = document.createElement('button');
        submitButton.type = 'submit';
        submitButton.innerText = 'common.pay'.t();
        submitButton.classList.add('btn');
        submitButton.classList.add('btn-primary');
        stripeForm.append(stripePaymentElement);
        stripeForm.append(submitButton);
        stripeForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            // Show loading state
            submitButton.disabled = true;
            submitButton.innerText = 'payment.processing'.t();
            const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: `${window.location.origin}/payment/confirmed`,
                }
            });
            if (error) {
                console.error(error);
                this.popupService.error(error.message);
                submitButton.disabled = false;
                submitButton.innerText = 'common.pay'.t();
            }
            else {
                this.notifyService.notify(`Stripe payment "${this.paymentId}" is complete`, 'info');
            }
        });
        document.body.append(stripeForm);
        document.body.append(scriptElement);
        await new Promise((resolve, reject) => {
            scriptElement.onload = () => resolve();
            scriptElement.onerror = () => reject(new Error('Stripe.js failed to load'));
            document.body.append(scriptElement);
        });
        const stripe = window.Stripe(process.env.STRIPE_PK);
        const elements = stripe.elements({ clientSecret: clientSecret });
        const paymentElement = elements.create('payment');
        paymentElement.mount('#stripe-payment-element');
        this.hideGatewayElements = true;
    }
    /**
     * Check payment status
     */
    async checkPaymentStatus() {
        if (!this.paymentId) {
            this.errorMessage = 'payment.noPaymentId'.t();
            return;
        }
        this.loading = true;
        try {
            const response = await this.apiService.back.get('payment.status', {
                routeParams: { id: this.paymentId }
            });
            if (response && response.success) {
                const paymentData = response.data;
                this.paymentStatus = paymentData.status;
                switch (paymentData.status) {
                    case backendImport_1.PaymentStatus.SUCCESS:
                        this.successMessage = 'payment.successful'.t();
                        this.$emit('payment-success', paymentData);
                        break;
                    case backendImport_1.PaymentStatus.REJECTED:
                        this.errorMessage = paymentData.failureReason || 'payment.rejected'.t();
                        this.$emit('payment-failed', paymentData);
                        break;
                    case backendImport_1.PaymentStatus.PENDING:
                        this.successMessage = 'payment.pending'.t();
                        this.$emit('payment-pending', paymentData);
                        break;
                    case backendImport_1.PaymentStatus.ERROR:
                        this.errorMessage = paymentData.failureReason || 'payment.error'.t();
                        this.$emit('payment-error', paymentData);
                        break;
                }
            }
            else {
                this.errorMessage = (response && response.error) || 'payment.statusCheckFailed'.t();
            }
        }
        catch (error) {
            console.error('Payment status check error:', error);
            this.errorMessage = 'payment.statusCheckFailed'.t();
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Test payment provider connection
     */
    async testConnection() {
        this.loading = true;
        this.errorMessage = '';
        this.successMessage = '';
        try {
            const response = await this.apiService.back.get('payment.test', {
                queryParams: { provider: this.provider }
            });
            if (response && response.success) {
                this.successMessage = 'payment.connectionSuccessful'.t();
            }
            else {
                this.errorMessage = (response && response.error) || 'payment.connectionFailed'.t();
            }
        }
        catch (error) {
            console.error('Payment connection test error:', error);
            this.errorMessage = 'payment.connectionFailed'.t();
            this.notifyService.notify(this.errorMessage, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Confirm payment with backend after Stripe confirmation
     */
    async confirmPaymentWithBackend(paymentIntentId) {
        var _a;
        try {
            const response = await this.apiService.back.post('payment.stripe.confirm', {
                paymentIntentId: paymentIntentId,
                paymentMethodId: undefined // Not needed for post-confirmation
            });
            if (response && response.success) {
                this.successMessage = 'payment.successful'.t();
                this.paymentStatus = backendImport_1.PaymentStatus.SUCCESS;
                this.notifyService.notify(this.successMessage, 'info');
                this.$emit('payment-success', { paymentIntentId, paymentId: this.paymentId });
                // Close the payment form
                (_a = document.body.querySelector('#stripe-form')) === null || _a === void 0 ? void 0 : _a.remove();
                this.hideGatewayElements = false;
            }
            else {
                this.errorMessage = (response === null || response === void 0 ? void 0 : response.error) || 'payment.confirmationFailed'.t();
                this.notifyService.notify(this.errorMessage, 'error');
            }
        }
        catch (error) {
            console.error('Payment confirmation error:', error);
            this.errorMessage = 'payment.confirmationFailed'.t();
            this.notifyService.notify(this.errorMessage, 'error');
        }
    }
    /**
     * Validate payment data before processing
     */
    validatePaymentData() {
        if (!this.provider) {
            this.errorMessage = 'payment.validation.providerRequired'.t();
            return false;
        }
        if (!this.amount || this.amount <= 0) {
            this.errorMessage = 'payment.validation.amountRequired'.t();
            return false;
        }
        if (!this.currency) {
            this.errorMessage = 'payment.validation.currencyRequired'.t();
            return false;
        }
        return true;
    }
    /**
     * Get current user's email (implement based on your auth system)
     */
    getCurrentUserEmail() {
        // TODO: Implement based on your authentication system
        // This is a placeholder
        return 'user@example.com';
    }
    /**
     * Reset component state
     */
    reset() {
        this.loading = false;
        this.paymentStatus = backendImport_1.PaymentStatus.PENDING;
        this.paymentUrl = '';
        this.paymentId = '';
        this.errorMessage = '';
        this.successMessage = '';
        this.sessionId = this.generateSessionId();
    }
    /**
     * Get payment provider display name
     */
    get paymentProviderName() {
        switch (this.provider) {
            case backendImport_1.PaymentProvider.STRIPE:
                return 'Stripe';
            default:
                return 'Unknown';
        }
    }
    /**
     * Get payment status display text
     */
    getStatusText() {
        switch (this.paymentStatus) {
            case backendImport_1.PaymentStatus.PENDING:
                return 'payment.status.pending'.t();
            case backendImport_1.PaymentStatus.SUCCESS:
                return 'payment.status.success'.t();
            case backendImport_1.PaymentStatus.REJECTED:
                return 'payment.status.rejected'.t();
            case backendImport_1.PaymentStatus.ERROR:
                return 'payment.status.error'.t();
            default:
                return 'payment.status.unknown'.t();
        }
    }
    /**
     * Get formatted amount for display
     */
    get formattedAmount() {
        if (!this.amount)
            return '';
        return `${this.amount} ${this.currency.toUpperCase()}`;
    }
    /**
     * Handle provider selection change
     */
    handleProviderChange(event) {
        const target = event.target;
        if (target.checked) {
            this.provider = target.value;
            // Reset payment state when provider changes
            this.reset();
        }
    }
};
exports.PaymentGateway = PaymentGateway;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], PaymentGateway.prototype, "paymentName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.PaymentProvider !== "undefined" && backendImport_1.PaymentProvider) === "function" ? _b : Object)
], PaymentGateway.prototype, "provider", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "description", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "sessionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], PaymentGateway.prototype, "amount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IAccountGrade !== "undefined" && backendImport_1.IAccountGrade) === "function" ? _c : Object)
], PaymentGateway.prototype, "accountGrade", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "billingPeriod", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "currency", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaymentGateway.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], PaymentGateway.prototype, "hideGatewayElements", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof backendImport_1.PaymentStatus !== "undefined" && backendImport_1.PaymentStatus) === "function" ? _d : Object)
], PaymentGateway.prototype, "paymentStatus", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "paymentUrl", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "paymentId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "errorMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], PaymentGateway.prototype, "successMessage", void 0);
exports.PaymentGateway = PaymentGateway = __decorate([
    (0, client_1.RWSView)('payment-gateway', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], PaymentGateway);
PaymentGateway.defineComponent();
